module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loadingAddress),
      expression: "loadingAddress",
      modifiers: {
        "opacity": true
      }
    }]
  }, [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('cep')
    }
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipCode),
      expression: "zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|cep'),
      expression: "'required|min:8|cep'"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cep",
      "value": "",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.zipCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.zipCode = $event.target.value
      }, _vm.queryAddressTyping]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('cep')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address2),
      expression: "address2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address",
      "value": "",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('address')) + "\n      ")])]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.errors.has('number')
    }
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:8'),
      expression: "'required|max:8'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number",
      "value": "",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('number')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('neighborhood')
    }
  }, [_c('label', {
    attrs: {
      "for": "neighborhood"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.neighborhood),
      expression: "neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "neighborhood",
      "value": "",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.neighborhood = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('neighborhood')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complement),
      expression: "complement"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.complement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.complement = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('city')
    }
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city",
      "value": "",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('city')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('state')
    }
  }, [_c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:2'),
      expression: "'required|max:2'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "state",
      "value": "",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('state')) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Complemento "), _c('span', [_vm._v("(opcional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-4ba6bf53!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/aggregate-register/address.vue
// module id = 2120
// module chunks = 1